import React from 'react'
import SimpleCard from 'components/SimpleCard'
import Main from 'layouts/main'
import { SimpleTitleCard } from 'styles/global'
import { BsKanban } from 'react-icons/bs'
import KanbanTab from './Tabs/KanbanTab'

const Kanban = () => {
  return (
    <Main>
      <SimpleCard>
        <SimpleTitleCard>
          <BsKanban className="icon" />
          Kanban
        </SimpleTitleCard>
        <KanbanTab />
      </SimpleCard>
    </Main>
  )
}

export default Kanban
